import { useRef, useState } from "react"
import { FaPause, FaPlay } from "react-icons/fa"
import { PropTypes } from 'prop-types';


const CourseDetailVideo = ({vid}) => {
    const poster = "/assets/poster2.svg"
    const videoRef = useRef(null)
    const [play, setPlay] = useState(false)

    const onPlay = () => {
        videoRef.current.play()
        setPlay(true)
    }
    const onPause = () => {
        videoRef.current.pause()
        setPlay(false)
    }
    return (
        <div className="w-full lg:w-5/6 h-[30rem]  rounded-xl relative overflow-hidden flex flex-1  mt-2 group">
            <video ref={videoRef} poster={poster} muted className="rounded-xl aspect-video object-cover w-full h-auto">
                <source src={vid} type="video/mp4" />
                <track kind="captions"></track>
            </video>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 transition-all ">
                {
                    play ?
                        <button aria-label="btnPause" className="text-[#f3f3f3] hidden group-hover:block" onClick={onPause}><FaPause size={40} /></button>
                        : <button aria-label="btnPlay" className="text-[#f3f3f3]" onClick={onPlay}><FaPlay size={40} /></button>
                }

            </div>
        </div>
    )
}
CourseDetailVideo.propTypes = {
    vid: PropTypes.string
}
export default CourseDetailVideo